import styled from "styled-components";
import {
  colors,
  spacings,
  borders,
  fontSizes,
  fontWeights,
} from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.lg};
  padding-bottom: ${spacings.xl};
`

export const Section = styled.div`
  background: ${colors.white};
  padding: ${spacings.ls};
  border-radius: ${borders.lg};
`

export const Summary = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: ${spacings.lg};
  margin: 0;

  dt {
    font-size: ${fontSizes.xs};
    font-weight: ${fontWeights.w700};
    color: ${colors.neutral_darker};
    margin-bottom: 4px;
  }

  dd {
    margin: 0;
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
    word-break: break-word;
  }
`

export const Actions = styled.div`
  display: flex;
  gap: ${spacings.lg};
  margin-bottom: ${spacings.lg};
`

export const JsonBlock = styled.pre`
  margin: 0;
  padding: ${spacings.lg};
  background: ${colors.neutral_light};
  border-radius: ${borders.lg};
  font-family: Menlo, Consolas, monospace;
  font-size: ${fontSizes.xs};
  white-space: pre-wrap;
  word-break: break-word;
  overflow: auto;
`
